// ProjectCard.jsx (New component file)
import React, { useState } from "react";
import { Link } from "react-router-dom"; // Make sure Link is imported
import QRCode from "./QRCode";

function ProjectCard({ project, usdPrice, tomiPrice, btcPrice }) {
  const {
    id,
    name,
    shortName,
    imageSrc,
    stats,
    calculateTotalPurchase,
    calculateMyEarnings,
    refLink,
    enabled
  } = project;

  // Helper conditions for clarity
  const hasPurchaseData = stats?.purchasedAndEarnings?.length > 0;
  const canCalculateTotal = usdPrice && tomiPrice && hasPurchaseData;
  const canCalculateEarnings =
    usdPrice && tomiPrice && btcPrice && hasPurchaseData;

  // Calculate values safely
  const totalPurchaseValue = canCalculateTotal
    ? `~$${parseFloat(calculateTotalPurchase()).toLocaleString("en-US")}`
    : "$0"; // Use $0 for consistency? Or keep original 0

    const myEarningsValue = canCalculateEarnings
        ? `~$${parseFloat(calculateMyEarnings()).toLocaleString("en-US")}`
        : "~$0.00 USD"; // Keep original fallback

    const [copied, setCopied] = useState(false);

    const handleCopy = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const text = document.getElementById(`referral-${id}`)?.innerText;
        if (text) {
            navigator.clipboard.writeText(text).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 1000); // Hide after 1s
            });
        }
    };
    // console.log(stats, 'statsstatsstats');
    const [showqrmodal, setShowQrModal] = useState(false);

    return (
        // <Link
        //   to="/dashboarddetail"
        //   onClick={() => {
        //     localStorage.setItem("project", id); // Use the project ID
        //   }}
        // >
        <div className="ongoingcard">
            <Link
                to="/dashboarddetail"
                onClick={() => {
                    localStorage.setItem("project", id); // Use the project ID
                }}
            >  <div className="ongoingcardupper">
                    <div className="ongoincardimg">
                        <img
                            src={imageSrc}
                            alt={`${name} logo`} // Better alt text
                            className="ongoingcardinnerimg"
                        />
                    </div>
                    <div className="ongoingcardtexts">
                        <h6 className="ongoingcardhead">{name}</h6>
                        <p className="ongoingcardpara">{shortName}</p>
                    </div>
                </div>
            </Link>
            <div className="ongoingcardlower">
                {/* Code */}
                <Link
                    to="/dashboarddetail"
                    onClick={() => {
                        localStorage.setItem("project", id); // Use the project ID
                    }}
                >
                    <div className="ongoingcardlowertexts">
                        <p className="cardlowertextspara">Code</p>
                        {/* Use optional chaining and provide a fallback */}
                        <h6 className="cardlowertextshead">{stats?.accessCode ?? "N/A"}</h6>
                    </div>
                </Link>
                {/* Referral link */}
                <div onClick={enabled ? handleCopy : () => { }} className="ongoingcardlowertexts">
                    <p className="cardlowertextspara">REFERRAL LINK</p>
                    {/* Use optional chaining and provide a fallback  */}
                    {refLink ?

                        <div className={enabled ? "maincopy" : "maincopy disabled"} style={{ position: "relative" }}>
                            <p className="copylink" id={`referral-${id}`}>
                                {refLink + stats?.accessCode + '&utm_source=leader_referral'}
                            </p>
                            <svg
                                className={enabled ? "" : " disabled"}
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                                style={{ cursor: "pointer" }}
                                onClick={enabled ? handleCopy : () => { }}
                            >
                                <path
                                    d="M6.93619 6.47851L6.95629 4.61208C6.96433 3.86539 6.96835 3.49176 7.11674 3.20813C7.24726 2.95864 7.45327 2.75702 7.70552 2.63189C7.99228 2.48965 8.36591 2.49367 9.1126 2.50171L12.8457 2.54191C13.5924 2.54995 13.9656 2.55397 14.2492 2.70236C14.4987 2.83288 14.7007 3.0389 14.8258 3.29114C14.968 3.5779 14.964 3.95125 14.956 4.69795L14.9158 8.43108C14.9077 9.17777 14.9037 9.55112 14.7553 9.83475C14.6248 10.0842 14.4182 10.2863 14.166 10.4114C13.8795 10.5535 13.5067 10.5495 12.7615 10.5415L10.8929 10.5213M6.93619 6.47851L5.06976 6.45841C4.32307 6.45037 3.94944 6.44635 3.66268 6.58859C3.41043 6.71371 3.20443 6.91533 3.0739 7.16482C2.92551 7.44846 2.92149 7.82208 2.91345 8.56878L2.87325 12.3019C2.86521 13.0486 2.86119 13.4217 3.00344 13.7085C3.12856 13.9607 3.33017 14.1671 3.57967 14.2976C3.86302 14.4459 4.23619 14.4499 4.98143 14.4579L8.71897 14.4982C9.46421 14.5062 9.83686 14.5102 10.1233 14.3681C10.3756 14.243 10.582 14.0408 10.7125 13.7913C10.8607 13.508 10.8647 13.1352 10.8728 12.39L10.8929 10.5213M6.93619 6.47851L8.80288 6.49861C9.54957 6.50665 9.92272 6.51067 10.2064 6.65906C10.4558 6.78958 10.6578 6.99559 10.7829 7.24784C10.9251 7.53432 10.921 7.9075 10.913 8.65275L10.8929 10.5213"
                                    stroke="#77868B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            {copied && (
                                <span
                                    style={{
                                        position: "absolute",
                                        bottom: "-25px",
                                        right: 0,
                                        fontSize: "12px",
                                        fontFamily: "hregular",
                                        color: "#329879",
                                        background: "#ecf5f9",
                                        padding: "2px 5px",
                                        borderRadius: "4px",
                                    }}
                                >
                                    Copied!
                                </span>
                            )}
                        </div>
                        :
                        <h6 className="cardlowertextshead">--</h6>
                    }



                </div>
                {/* No. of Purchases */}
                <Link
                    to="/dashboarddetail"
                    onClick={() => {
                        localStorage.setItem("project", id); // Use the project ID
                    }}
                > <div className="ongoingcardlowertexts">
                        <p className="cardlowertextspara">No. of Purchases</p>
                        {/* Removed redundant h6, added fallback */}
                        <h6 className="cardlowertextshead">{stats?.totalPurchases || 0}</h6>
                    </div>
                </Link>
                {/* Total Purchases */}
                <Link
                    to="/dashboarddetail"
                    onClick={() => {
                        localStorage.setItem("project", id); // Use the project ID
                    }}
                >
                    <div className="ongoingcardlowertexts">
                        <p className="cardlowertextspara">Total Purchases</p>
                        {/* Removed redundant h6 */}
                        <h6 className="cardlowertextshead">{totalPurchaseValue}</h6>
                    </div>
                </Link>
                {/* My Earning */}
                <Link
                    to="/dashboarddetail"
                    onClick={() => {
                        localStorage.setItem("project", id); // Use the project ID
                    }}
                >
                    <div className="ongoingcardlowertexts">
                        <p className="cardlowertextspara">My Earning</p>
                        {/* Removed redundant h6 */}
                        <h6 className="cardlowertextshead">{myEarningsValue}</h6>
                    </div>
                </Link>
            </div>
            <button onClick={() => enabled ? setShowQrModal(true) : setShowQrModal(false)} className={enabled ? "btn-share" : "btn-share disabled"}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M5.25 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V5.25C2.25 5.66421 2.58579 6 3 6H5.25C5.66421 6 6 5.66421 6 5.25V3C6 2.58579 5.66421 2.25 5.25 2.25Z" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15 2.25H12.75C12.3358 2.25 12 2.58579 12 3V5.25C12 5.66421 12.3358 6 12.75 6H15C15.4142 6 15.75 5.66421 15.75 5.25V3C15.75 2.58579 15.4142 2.25 15 2.25Z" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.25 12H3C2.58579 12 2.25 12.3358 2.25 12.75V15C2.25 15.4142 2.58579 15.75 3 15.75H5.25C5.66421 15.75 6 15.4142 6 15V12.75C6 12.3358 5.66421 12 5.25 12Z" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.75 12H13.5C13.1022 12 12.7206 12.158 12.4393 12.4393C12.158 12.7206 12 13.1022 12 13.5V15.75" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.75 15.75V15.76" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 5.25V7.5C9 7.89782 8.84196 8.27935 8.56066 8.56066C8.27935 8.84196 7.89782 9 7.5 9H5.25" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2.25 9H2.26" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 2.25H9.01" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 12V12.01" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 9H12.75" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.75 9V9.01" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 15.75V15" stroke="#02171D" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" />
            </svg> Share QR Code</button>
            <QRCode showqrmodal={showqrmodal} setShowQrModal={setShowQrModal} qrData={refLink + stats?.accessCode + '&utm_source=leader_referral'} saleName={name} />
        </div>
        // </Link>
       
    );
}

export default ProjectCard;
